import React, { useEffect, useState, useRef } from "react";
import { resetToastData } from "@store/slices/globalState";
import { CSSTransition } from "react-transition-group";
import { styled, Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { useDispatch, useSelector } from "react-redux";


const enterDuration = 1000;
const exitDuration = 1000;

const ToastContainer = styled(Box)`
  position: absolute;
  z-index: 100;
  left: 47%;
  transform: translateX(-50%);
  text-align: center;
  bottom: -100px;
  width: 90%;

  @media (min-width: 768px) {
    width: 490px;
    left: 40%;
    transform: translateX(0%);
  }

  &.slide-up-enter {
    opacity: 0.5;
    bottom: -100px;
  }
  &.slide-up-enter-active {
    opacity: 1;
    bottom: 40px;
    transition: all ${enterDuration}ms;
  }
  &.slide-up-enter-done {
    opacity: 1;
    bottom: 40px;
  }

  &.slide-up-exit {
    opacity: 1;
    bottom: 40px;
  }
  &.slide-up-exit-active {
    opacity: 1;
    bottom: -100px;
    transition: all ${exitDuration}ms;
  }
  &.slide-up-exit-done {
    display: none;
  }
`;

const Toast = styled(Flex)`
  background: #040222;
  padding: 8px;
  border-radius: 8px;
  gap: 0.75rem;
  color: white;
  font-weight: 400;
  font-size: 14px;
  line-height: 4px;
  align-items: center;
`;

const CancelRedComponent = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
// const SlideUo = keyframes`
// 0% {
//   bottom: 0px;
// }
// 70%{
//   bottom: 100px;
// }
// 100% {
//   bottom: 0px;
// }
// `;
// const ToastContainer = styled(Box)`
//   width: 200px;
//   height: 3rem;
//   position: absolute;
//   z-index: 100;
//   left: 50%;
//   transform: translateX(-50%);
//   animation: ${SlideUo} 2s ease-in-out;
// `;

const ToastWrap = () => {
  const dispatch = useDispatch();
  const { toastData } = useSelector(({ globalState }: any) => {

    return {
      toastData: globalState.toastData
    };
  });

  const { toastMessage, toastMessageType, timeout } = toastData || {};

  const toastMessageRef = useRef("");

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (toastMessage && toastMessageType) {
      setShow(true);
      toastMessageRef.current = toastMessage;
    }
  }, [toastMessage, toastMessageType]);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
        dispatch(resetToastData());
      }, timeout);
    }
  }, [show]);

  return (
    <>
      <CSSTransition
        in={show}
        timeout={{
          appear: enterDuration,
          enter: enterDuration,
          exit: exitDuration
        }}
        classNames={"slide-up"}
        appear
        unmountOnExit
      >
        <ToastContainer >
          <Toast>
          <CancelRedComponent src="https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/cancel-red.svg" />{" "}
          <p>{toastMessageRef.current}</p>
          </Toast>
        </ToastContainer>
      </CSSTransition>
    </>
  );
};

export default ToastWrap;
